var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"spinner-grow text-primary",class:_vm.spinnerSize,attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }